import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogMoldSize } from "../../../models/CatalogMoldSize";
type Props = {
  setMoldSize: (mold: CatalogMoldSize) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewMoldSize: () => void;
};
export const useMoldSizeOptionsFunctions = ({
  setMoldSize,
  setShowModal,
  handleNewMoldSize,
}: Props) => {
  const getMenuOptions = (data: CatalogMoldSize) => {
    let options: MenuOptionType[] = [
      {
        name: "New Mold Size",
        key: "new_mold_size",
        onClick: () => {
          handleNewMoldSize();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Mold Size",
          key: "edit_mold_size",
          onClick: () => {
            setMoldSize(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Mold Size",
          key: "delete_mold_size",
          onClick: () => {
            setMoldSize(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
